import { useAuth0, User } from "@auth0/auth0-react";
import { useEffect } from "react";
import Loading from "./Loading";
import { useNavigate } from "react-router-dom";
import useGetUserData from "../hooks/useGetUserData";
import { deleteSelf, getAllDataForSelf, verifySelf } from "../core/services/gutcheck-api.service";
import { useUserContext } from "../features/users";
import useAnalytics from "../hooks/useAnalytics";
import Membership from "../features/users/types/Membership";


export const SilentLogin = ({auth0User, isLoading}: { auth0User: User | undefined, isLoading: boolean }) => {
  const navigate = useNavigate();
  const { getAccessTokenSilently }  = useAuth0();

  const { loginWithRedirect, logout } = useAuth0();
  const [ fetched, user ] = useGetUserData();
  const { userContext, setUserContext, loadUserContext } = useUserContext();
  const { trackUser } = useAnalytics();


  useEffect(() => {

    if (!isLoading) loadUserContext();

  }, []);

  useEffect(() => {
    const revertSignUp = async () => {
      const accessToken = await getAccessTokenSilently();
      const { data, error } = await deleteSelf(accessToken);
      logout({ logoutParams: { returnTo: `${document.location.origin}/unrecognized` }});

    }

    const completeSignUp = async () => {
      loginWithRedirect({
        appState: {
          returnTo: "/dashboard",
        },
        authorizationParams: {
          prompt: "none"
        },
      });
    }

    // User exists and is verified
    if (!isLoading && fetched && user && auth0User?.email_verified) {
      //const redirectUri = localStorage.getItem("redirectUri");
      //localStorage.removeItem("redirectUri");
      //if (redirectUri && /^https?:\/\//.test(redirectUri)) {
      //  window.location.href = redirectUri;
      //  return;
      //} else {
        return navigate("/");  
      //}
    }

    // Users exists and is not verified
    if (!isLoading && fetched && user) {
      completeSignUp();
    };

    // User signed up but was rejected
    if (!isLoading && fetched && auth0User && !user) {
      //revertSignUp();
    }

    // User not authenticated
    if (!isLoading && fetched && !auth0User) {
      completeSignUp();
    }

    // return navigate("/", { state: { triedSilentLogin: true }});

  }, [ fetched, user ]);

  return (
      <Loading />
  );
};
